import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import { invalidateCustomerDocumentCategoryCache, useApproveDocumentCategory } from 'src/api/customer-document-category'
import { GenericDialogLayout } from 'src/components/GenericDialogLayout'
import { ShowDialogProps } from 'src/show-dialog'
import { toast } from 'react-toastify'
import { Box, Button, Typography } from '@mui/material'

interface ApproveCustomerDocumentCategoryProps extends ShowDialogProps {
  customerId: EntityId
  id: EntityId
  isEnabled: boolean
}

export const ApproveDocumentCategoryDialog: React.FC<ApproveCustomerDocumentCategoryProps> = ({
  pop,
  id,
  customerId,
  isEnabled,
}) => {
  const { t: translate } = useTranslation(['document-category', 'common', 'common-api-massage'])
  const { mutateAsync, isLoading } = useApproveDocumentCategory(customerId, id as EntityId)

  const onSubmit = useCallback(async () => {
    await mutateAsync(
      { isEnabled },
      {
        onSuccess: () => {
          toast.success(translate('successfullyUpdated', { ns: 'common-api-massage' }))
          invalidateCustomerDocumentCategoryCache.getCustomerDocumentCategories(customerId)
          invalidateCustomerDocumentCategoryCache.getCustomerDocumentCategory(customerId, id)
          invalidateCustomerDocumentCategoryCache.getCustomerAndAdminDocumentCategories(customerId)
          invalidateCustomerDocumentCategoryCache.getSystemAdminDocumentCategoriesForCustomer(customerId)
          pop(true)
        },
        onError: () => {
          toast.error(translate('unExpectedError', { ns: 'common-api-massage' }))
        },
      },
    )
  }, [translate, customerId, id, pop])

  return (
    <GenericDialogLayout
      title={translate(isEnabled ? 'approve-document-category' : 'reject-document-category', {
        ns: 'document-category',
      })}
      pop={pop}
    >
      <Typography sx={{ p: 1 }} variant="subtitle1">
        {translate(isEnabled ? 'confirm-approve' : 'confirm-reject', { ns: 'document-category' })}
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={onSubmit}
          disabled={isLoading}
          sx={{ mt: 2, textTransform: 'none' }}
        >
          {translate('yes', { ns: 'common' })}
        </Button>
      </Box>
    </GenericDialogLayout>
  )
}
